'use strict';exports.__esModule = true;var _extends = Object.assign || function (target) {for (var i = 1; i < arguments.length; i++) {var source = arguments[i];for (var key in source) {if (Object.prototype.hasOwnProperty.call(source, key)) {target[key] = source[key];}}}return target;};var _react = require('react');var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');var _propTypes2 = _interopRequireDefault(_propTypes);
var _classnames = require('classnames');var _classnames2 = _interopRequireDefault(_classnames);
var _components = require('../../components');

var _appendLocale = require('../../helpers/appendLocale');var _appendLocale2 = _interopRequireDefault(_appendLocale);

var _MenuDropdownProperty = require('./MenuDropdownProperty.scss');var styles = _interopRequireWildcard(_MenuDropdownProperty);function _interopRequireWildcard(obj) {if (obj && obj.__esModule) {return obj;} else {var newObj = {};if (obj != null) {for (var key in obj) {if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];}}newObj.default = obj;return newObj;}}function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self, call) {if (!self) {throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call && (typeof call === "object" || typeof call === "function") ? call : self;}function _inherits(subClass, superClass) {if (typeof superClass !== "function" && superClass !== null) {throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);}subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;}var

MenuDropdownProperty = function (_Component) {_inherits(MenuDropdownProperty, _Component);function MenuDropdownProperty() {var _temp, _this, _ret;_classCallCheck(this, MenuDropdownProperty);for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {args[_key] = arguments[_key];}return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.
    state = {
      collapsed: false }, _this.












    options = function () {var _this$props =




      _this.props,translate = _this$props.translate,getRoute = _this$props.getRoute,locale = _this$props.locale;
      var options = [
      {
        name: 'leads',
        displayName: translate('header', 'addIsraelProperty'),
        props: {
          onClick: getRoute((0, _appendLocale2.default)(locale, '/publish')) } },


      {
        name: 'editProfile',
        displayName: translate('header', 'AddForeignProperty'),
        props: {
          onClick: getRoute((0, _appendLocale2.default)(locale, '/foreign_publish')) } }];




      return options;
    }, _this.

    handleClick = function (evt) {
      if (
      !_this.state.collapsed ||
      !_this.dropdownList ||
      evt.target.classList.contains(styles.titleContainer) ||
      _this.props.triggerIds.includes(evt.target.id))
      {
        return undefined;
      }

      return _this.setState({ collapsed: false });
    }, _this.

    openCollapsedList = function () {return _this.setState({ collapsed: !_this.state.collapsed });}, _this.

    renderItem = function () {return (
        _this.options().map(function (option) {return (
            _react2.default.createElement('li', _extends({ key: option.name }, option.props),
              _react2.default.createElement('div', { className: styles.menuIcon },
                _react2.default.createElement('span', { className: 'icon icon-plusIcon' }), '\xA0\xA0'),

              _react2.default.createElement('div', { className: styles.menuLabel },
                _react2.default.createElement('div', null, option.displayName))));}));}, _temp), _possibleConstructorReturn(_this, _ret);}MenuDropdownProperty.prototype.componentWillMount = function componentWillMount() {if (global && global.window) {window.addEventListener('mouseup', this.handleClick);}};MenuDropdownProperty.prototype.componentWillUnmount = function componentWillUnmount() {window.removeEventListener('mouseup', this.handleClick);};MenuDropdownProperty.prototype.





  render = function render() {var _cx,_cx2,_this2 = this;var
    collapsed = this.state.collapsed;var _props =
    this.props,innerRef = _props.innerRef,translate = _props.translate,onClick = _props.onClick,isMobile = _props.isMobile,isManageProperties = _props.isManageProperties,isDisabled = _props.isDisabled;
    var caretStyle = 'caret-' + (collapsed ? 'up' : 'down');

    return (
      _react2.default.createElement('div', {
          className: (0, _classnames2.default)(
          styles.container, (_cx = {}, _cx[
          styles.collapsed] = collapsed, _cx), (_cx2 = {}, _cx2[
          styles.collapsedManageProperties] = isManageProperties, _cx2)) },


        _react2.default.createElement('div', {
            ref: function ref(_ref) {innerRef && innerRef(_ref);},
            className: styles.titleContainer,
            onClick: !isDisabled && this.openCollapsedList },

          isManageProperties ?
          _react2.default.createElement(_components.OMPublishButton, {
            translate: translate,
            isForein: true }) :

          _react2.default.createElement(_components.PublishPropertyButton, {
            title: '' + translate('header', 'publishProperty'),
            theme: 'foreign',
            size: isMobile ? 'small' : 'medium',
            universal: true,
            onClick: onClick,
            isDisabled: isDisabled,
            id: 'publishPropertyButton',
            titleId: 'publishPropertyButtonTitle',
            caret: _react2.default.createElement('div', { className: styles.caret + ' ' + styles[caretStyle] }) })),




        _react2.default.createElement('ul', { className: styles.list, ref: function ref(_ref2) {_this2.dropdownList = _ref2;} },
          this.renderItem())));



  };return MenuDropdownProperty;}(_react.Component);


MenuDropdownProperty.propTypes = {
  innerRef: _propTypes2.default.func,
  triggerIds: _propTypes2.default.array,
  className: _propTypes2.default.string,
  options: _propTypes2.default.array,
  translate: _propTypes2.default.func,
  getRoute: _propTypes2.default.func,
  onClick: _propTypes2.default.func,
  locale: _propTypes2.default.string,
  isMobile: _propTypes2.default.bool,
  isManageProperties: _propTypes2.default.bool,
  isDisabled: _propTypes2.default.bool };exports.default =


MenuDropdownProperty;module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/MenuDropdownProperty/MenuDropdownProperty.js
// module id = 2720
// module chunks = 0